<template>
  <div class="slide-banner">
    <div class="slide-banner-scroll" ref="slide">
      <div class="slide-banner-wrapper">
        <div class="slide-item page1" v-for="item in imgCollection" :key="item.src">
          <img :src="item.src" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BS from '@better-scroll/core'
import Slide from '@better-scroll/slide'

BS.use(Slide)

export default {
  name: 'Slider',
  props: {
    imgCollection: Array
  },
  data() {
    return {
      slide: null,
      playTimer: 0,
      currentPageIndex: 0,
    }
  },
  mounted() {
    setTimeout(() => {
      this.init()
    }, 200)
  },
  beforeDestroy() {
    clearTimeout(this.playTimer)
    this.slide.destroy()
  },
  methods: {
    init() {
      clearTimeout(this.playTimer)
      this.slide = new BS(this.$refs.slide, {
        scrollX: true,
        scrollY: false,
        slide: {
          loop: true,
          threshold: 100
        },
        eventPassthrough: 'vertical',
        useTransition: true,
        momentum: false,
        bounce: false,
        stopPropagation: true,
        probeType: 2
      })
      this.slide.on('scrollEnd', this._onScrollEnd)

      // user touches the slide area
      this.slide.on('beforeScrollStart', () => {
        clearTimeout(this.playTimer)
        this.autoGoNext()
      })
      // user touched the slide done
      this.slide.on('scrollEnd', () => {
        this.autoGoNext()
      })
      this.slide.on('slideWillChange', (page) => {
        this.currentPageIndex = page.pageX
      })
      this.autoGoNext()
    },
    nextPage() {
      this.slide.next()
    },
    prePage() {
      this.slide.prev()
    },
    _onScrollEnd() {
      this.autoGoNext()
    },
    autoGoNext() {
      clearTimeout(this.playTimer)
      this.playTimer = setTimeout(() => {
        this.nextPage()
      }, 1500)
    }
  }

}
</script>

<style lang="less" scoped>
.slide-banner-scroll {
  min-height: 1px;
  overflow: hidden;
}
.slide-banner-wrapper {
  min-height: 10rem;
  // height: 200px;
  white-space: nowrap;
  font-size: 0;
}
.slide-item {
  display: inline-block;
  min-height: 10rem;
  width: 100%;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
